// extracted by mini-css-extract-plugin
module.exports = {"container":"Initial_container__d3ang","content":"Initial_content__qKWjh","icons":"Initial_icons__2blXF","title":"Initial_title__1Ffom","msg_error":"Initial_msg_error__1Mcln"};